import { observer } from 'mobx-react-lite';
import { useEntityPanelManager } from '../../../panels/entity-panels/monitored-entities/state/entity-panel-manager';
import { useWorkspacePanel } from '../../../panels/hooks/use-workspace-panel';
import { useBoloPanelMetadata } from './bolo-panel-metadata-context';
import { useFormContext } from 'react-hook-form';
import { BoloPanelFormType } from '@mark43/cad-api';
import { useEffect } from 'react';

export const BoloManagerRegister = observer(() => {
    const entityPanelManager = useEntityPanelManager();
    const workspacePanel = useWorkspacePanel();
    const metadata = useBoloPanelMetadata();
    const boloForm = useFormContext<BoloPanelFormType>();

    useEffect(() => {
        if (!metadata) {
            return;
        }

        entityPanelManager.setBoloPanel(workspacePanel.uuid, {
            boloId: metadata.boloId,
            form: boloForm,
            metadata,
            workspacePanel,
        });

        return () => {
            entityPanelManager.removeBoloPanel(workspacePanel.uuid);
        };
    }, [boloForm, entityPanelManager, workspacePanel, metadata]);

    return null;
});
